// import axios from 'axios'
import { post, put, get } from '@/api/api'

export const actions = {
  fetchPermissions({ commit }) {
    return get(`/user/permissions/all`)
      .then(({ data }) => {
        commit('addPermissions', data)
      })
  },
  async fetchPermissionsPage({commit}, params = {}) {
    const { page = 0, size = 10, sort = '' } = params;
    const queryParams = new URLSearchParams({
      page,
      size,
      sort
    }).toString();

    let { data } = await get(`/user/permissions?${queryParams}`);
    commit("addPermissions", data)
    return data;
  },
  createPermissions ({ commit }, permissions) {
    return post("/user/permissions/add", permissions).then(({ data }) => {
      commit("addPermissions", data);
    });
  },
  updatePermissions ({ commit }, permissions) {
    return put(`/user/permissions/edit/${permissions.id}`, permissions).then(({ data }) => {
      commit("replacepermissions", data);
    });
  },
  createOrUpdatePermissions ({ dispatch }, permissions) {
    if (permissions.id !== undefined) {
      return dispatch('updatePermissions', permissions)
    } else {
      return dispatch('createPermissions', permissions)
    }
  },
  selectpermissions ({ commit }, permissions) {
    commit('setpermissions', permissions)
  }
}
